import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Card = styled.div`
  background-color: ${props => props.gradient ? 'transparent' : props.theme.colors.cardDark};
  border-radius: 16px;
  box-shadow: ${props => props.theme.boxShadow.small};
  padding: ${props => props.padding || '1.8rem'};
  margin-bottom: ${props => props.noMargin ? '0' : '1.5rem'};
  transition: ${props => props.theme.transition.default};
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.5s ease-out;
  border: 1px solid ${props => props.bordered ? props.theme.colors.border : 'transparent'};
  backdrop-filter: blur(5px);
  
  ${props => props.gradient && css`
    background: ${props => 
      props.gradient === 'primary' ? props.theme.colors.gradient1 : 
      props.gradient === 'secondary' ? props.theme.colors.gradient2 : 
      props.gradient === 'accent' ? props.theme.colors.gradient3 : 
      props.theme.colors.gradient1
    };
    color: white;
  `}
  
  ${props => props.hoverable && css`
    &:hover {
      transform: translateY(-8px);
      box-shadow: ${props => props.theme.boxShadow.hover};
      background-color: ${props => !props.gradient && props.theme.colors.darkBg2};
      
      &::before {
        opacity: 1;
      }
    }
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: ${props => 
        props.gradient === 'primary' ? props.theme.colors.gradient1 : 
        props.gradient === 'secondary' ? props.theme.colors.gradient2 : 
        props.gradient === 'accent' ? props.theme.colors.gradient3 : 
        props.theme.colors.gradient1
      };
      opacity: 0;
      transition: opacity 0.3s ease;
      border-radius: 16px 16px 0 0;
    }
  `}
  
  ${props => props.clickable && css`
    cursor: pointer;
    
    &:active {
      transform: translateY(-2px);
    }
  `}
  
  ${props => props.bordered && css`
    border: 1px solid ${props => props.theme.colors.border};
  `}
  
  ${props => props.elevated && css`
    box-shadow: ${props => props.theme.boxShadow.medium};
  `}
  
  ${props => props.glassmorphism && css`
    background: rgba(26, 26, 26, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.05);
  `}
`;

export default Card; 